import { GetResponse } from '@customTypes/api/Employee';
import log from '@src/datadog';

const useDatadogTrackerEffect = (employeeDetail?: GetResponse) => {
  if (!employeeDetail) return;

  const datadogUser = {
    id: employeeDetail.marketing_id,
    branchId: employeeDetail.branch_id,
    email: employeeDetail.corporate_email,
    name: employeeDetail.emp_name,
    empNo: employeeDetail.emp_no,
    jobTitleCode: employeeDetail.job_title_code,
    jobTitleName: employeeDetail.job_title_name,
    productType: employeeDetail.product_type,
    role: employeeDetail.role,
  };

  if (!log.getDDUser() || Object.keys(log.getDDUser()).length === 0) {
    log.setDDUser(datadogUser);
  } else {
    log.updateDDUser(datadogUser);
  }
};

export default useDatadogTrackerEffect;
